import styled from 'styled-components';

import { SIZE, GRADIENT, WHITE, GRADIENT_VERTICAL } from '../../const';
import img728 from '../../images/ads/fcc-horizontal-728x90.png';
import ExperianImg300 from '../../images/ads/experian-boost_300x250.png';

export const StyledCallToAction = styled.div`
    width: 100%;
    max-width: 728px;
    display: flex;
    justify-content: center;
    margin-bottom: ${props => props.isCareers ? '0' : '45px'};

    > a {
        width: 100%;
        height: 90px;
        background-image: url(${img728});
    }

    @media (max-width: 810px) {
        > a {
            width: 300px;
            height: 250px;
            background-image: url(${ExperianImg300});
        }
    }

    .content {
        height: 90px;
        width: 100%;
        padding: 27px 33px;
        border-radius: 7px;
        background: ${GRADIENT};
        color: ${WHITE};
        display: flex;
        justify-content: space-between;
        align-items: center;

        span {
            @media (max-width: 810px) {
                margin-bottom: 40px;
            } 
        }

        @media (max-width: 810px) {
            max-width: initial;
            flex-direction: column;
            padding: 50px 18px 40px;
            font-weight: bold;
            height: auto;
            font-size: 21px;
            line-height: 29px;
            text-align: center;
        }
    }
`;

export const StyledCallToActionVertical = styled.div`
    width: 100%;
    height: 600px;
    max-width: 300px;
    display: flex;
    flex-direction: column;
    justify-content: flex-end;
    text-align: center;
    padding: 10px 25px;
    align-items: center;
    background: ${GRADIENT_VERTICAL}, url(${props => props.bk});
    background-size: cover;
    background-position: 75% 0%;
    background-repeat: no-repeat;
    color: ${WHITE};
    margin-bottom: 30px;

    .title {
        font-weight: bold;
        font-size: 28px;
        line-height: 38px;
        margin-bottom: 8px;
    }

    .description {
        font-size: 14px;
        line-height: 19px;
        margin-bottom: 24px;
    }

    .button {
        margin-bottom: 30px;
    }

    &.rightBlockCta {
        margin-bottom: 94px;
    }

    @media ${SIZE.categorySwitch} {
        display: none;     
    }

    @media ${SIZE.categorySwitch} {
        height: 420px;
    }
`;